import { render } from "./StrokedArrowUpIcon.vue?vue&type=template&id=1648e8c7"
import script from "./StrokedArrowUpIcon.vue?vue&type=script&lang=js"
export * from "./StrokedArrowUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__